import { IStateService } from 'angular-ui-router';
import { EmptyGuid, Guid } from '@Shared.Angular/@types/guid';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { WorkflowAccessLevel } from '@Shared.Angular/@types/core/contracts/constants/workflowAccessLevel';

export const navigateToStartFlow = (
  dataItem: Pick<
    { id: Guid; workflowStatus: WorkflowAccessLevel },
    'id' | 'workflowStatus'
  >,
  $state: IStateService,
  browserWindow: Window = window
): void => {
  if (dataItem.workflowStatus === WorkflowAccessLevel.PublicForm) {
    const url = $state.href(STATE_MAPPINGS.publicForm, { id: dataItem.id });
    const publicFormWindow = browserWindow.open(
      browserWindow.location.origin + url,
      '_blank'
    );
    publicFormWindow?.focus();
    return;
  }

  $state.go(STATE_MAPPINGS.flow, {
    flowId: EmptyGuid,
    flowModelId: dataItem.id
  });
};
